import { render, staticRenderFns } from "./AsideToggler.vue?vue&type=template&id=531a3d42"
import script from "./AsideToggler.vue?vue&type=script&lang=js"
export * from "./AsideToggler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports